<section class="extra-form-field">
  <slot></slot>
  <slot name="label"></slot>
</section>

<style lang="scss">
  .extra-form-field {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: 3px;

    :global(span[slot='label']) {
      font-size: 14px;
      line-height: 16px;
      font-weight: 400;
    }
  }
</style>
